import {
  USER_PERMISSIONS_LIST,
  USER_PERMISSIONS_LIST_SUCCESS,
  USER_PERMISSIONS_LIST_ERROR,
  USER_PERMISSIONS_NEW,
  USER_PERMISSIONS_NEW_SUCCESS,
  USER_PERMISSIONS_NEW_ERROR,
  USER_PERMISSIONS_EDIT,
  USER_PERMISSIONS_DELETE,
  USER_PERMISSIONS_DELETE_SUCCESS,
  USER_PERMISSIONS_DELETE_ERROR,
  USER_PERMISSIONS_TYPES_LIST,
  USER_PERMISSIONS_TYPES_LIST_SUCCESS,
  USER_PERMISSIONS_TYPES_LIST_ERROR,
} from "./actionTypes"

const initialState = {
  responseList: "",
  loadingList: false,
  errorList: "",
  responseNew: "",
  loadingNew: false,
  errorNew: "",
  responseDelete: "",
  loadingDelete: false,
  errorDelete: "",
  responseTypesList: "",
  loadingTypesList: false,
  errorTypesList: "",
}

const UserPermissions = (state = initialState, action) => {
  switch (action.type) {
    case USER_PERMISSIONS_LIST:
      state = {
        ...state,
        loadingList: true,
        errorList: "",
      }
      break
    case USER_PERMISSIONS_LIST_SUCCESS:
      state = {
        ...state,
        loadingList: false,
        responseList: action.payload.data
      }
      break
    case USER_PERMISSIONS_LIST_ERROR:
      state = {
        ...state,
        loadingList: false,
        errorList: action.payload
      }
      break
    case USER_PERMISSIONS_NEW:
      state = {
        ...state,
        loadingNew: true,
        responseNew: "",
        errorNew: ""
      }
      break
    case USER_PERMISSIONS_NEW_SUCCESS:
      state = {
        ...state,
        loadingNew: false,
        responseNew: action.payload.data
      }
      break
    case USER_PERMISSIONS_NEW_ERROR:
      state = {
        ...state,
        loadingNew: false,
        errorNew: action.payload
      }
      break
    case USER_PERMISSIONS_EDIT:
      state = {
        ...state,
        loadingNew: true,
        responseNew: "",
        errorNew: ""
      }
      break
    case USER_PERMISSIONS_DELETE:
      state = {
        ...state,
        loadingDelete: true,
        responseDelete: "",
        errorDelete: ""
      }
      break
    case USER_PERMISSIONS_DELETE_SUCCESS:
      state = {
        ...state,
        loadingDelete: false,
        responseDelete: action.payload.data
      }
      break
    case USER_PERMISSIONS_DELETE_ERROR:
      state = {
        ...state,
        loadingDelete: false,
        errorDelete: action.payload
      }
      break
    case USER_PERMISSIONS_TYPES_LIST:
      state = {
        ...state,
        loadingTypesList: true,
        responseTypesList: "",
        responseNew: "",
        errorTypesList: "",
        errorNew: "",
        errorEdit: "",
      }
      break
    case USER_PERMISSIONS_TYPES_LIST_SUCCESS:
      state = {
        ...state,
        loadingTypesList: false,
        responseTypesList: action.payload.data
      }
      break
    case USER_PERMISSIONS_TYPES_LIST_ERROR:
      state = {
        ...state,
        loadingTypesList: false,
        errorTypesList: action.payload
      }
      break
    default:
      state = {...state}
      break
  }
  return state
}

export default UserPermissions
